import {captureException} from '@sentry/nextjs'
import habo from 'habo'
import {EVENT_ID_CHECK_MAP, IEventName, getEventId} from '@/constants/haboEventId'
import getUaParam from '@/utils/getUaParam'
import {timeReportIOS} from '@/plugins/bridge'
import {haboLog} from '@/utils/log'

const {
    userId: user_id,
    pageSource: page_source,
    isApp,
    appConfig,
} = getUaParam()
try {
    habo.setConfig({
        NAME: isApp ? appConfig.appHaboBizName : appConfig.mHaboBizName || 'gt-m',
        VERB: 'get',
        TIMEOUT: '15000',
        // 接入轻舟GAPM
        APPNID: 'baijia.gtbg.fe.bj.bamboo-book-content',
        DELAY: false,
    })
}
catch (error) {
    captureException(new Error('哈勃初始化失败'))
}

/**
 * @description: 埋点上报(点击、曝光)
 * @param eventName: 埋点名称
 * @param other: 额外参数
 */
export const haboClickReport = async (eventName: IEventName, ...others: IReportInfo[]) => {
    const eventId = getEventId(eventName)
    const resolved = await Promise.all(others)
    let params = Object.assign({eventId, user_id, page_source}, ...resolved)
    // 如果接口请求失败, 则不上报
    if (params.fail) {
        return
    }
    params = JSON.parse(JSON.stringify(params))
    // 检查必填参数是否齐全
    const checkList = EVENT_ID_CHECK_MAP[eventName] || []
    for (const check of checkList) {
        if (params[check] === undefined) {
            console.log(`【REPORT】${eventName}:${eventId} 缺失必填参数 ${check}`)
            return
        }
    }
    habo.click(params)
    haboLog(eventName, eventId, params)
}

// 时长上报
const timeMap: { [eventId: number]: number } = {}

/**
 * @description: 时长上报开始(实际由useTimeReport调用)
 * @param eventName: 埋点名称
 * @param other: 额外参数
 */
export const haboTimeStart = (eventName: IEventName, other = {}) => {
    const eventId = getEventId(eventName)
    timeMap[eventId] = +new Date()
    // 调端能力, 由客户端来报最后一次时间, 没次调都会更新开始时间
    timeReportIOS(eventName, {user_id, ...other})
}

/**
 * @description: 时长上报结束(实际由useTimeReport调用)
 * @param eventName: 埋点名称
 * @param other: 额外参数
 */
export const haboTimeEnd = (eventName: IEventName, other = {}) => {
    const eventId = getEventId(eventName)
    const start = timeMap[eventId]
    if (!start) {
        return -1
    }
    timeMap[eventId] = 0
    const stay_time = +new Date() - start
    const params = {
        eventId,
        stay_time,
        user_id,
        ...other,
    }
    habo.click(params)
}

/**
 * @description: 获取页面fcp
 * @return fcp
 */
const getFcp = () => {
    if (performance?.getEntriesByName) {
        return performance.getEntriesByName('first-contentful-paint')[0]?.startTime || 0
    }
    // @ts-ignore
    if (window?.chrome?.loadTimes) {
        // @ts-ignore
        const {firstPaintTime, startLoadTime} = window.chrome.loadTimes()
        return (firstPaintTime - startLoadTime) * 1000
    }
    return 0
}

/**
 * @description: habo手动上报时长
 * @param type: 上报类型
 */
export const haboPerf = (type: 'fmp' | 'fcp' = 'fmp') => {
    switch (type) {
    case 'fmp': {
        // SSR中fcp就是fmp
        const fmp = getFcp()
        if (fmp) {
            habo.perf({fmp})
        }
        break
    }
    case 'fcp': {
        const fcp = getFcp()
        if (fcp) {
            habo.perf({fcp})
        }
        break
    }
    }
}
